import React from 'react'
import CardContent from '../CardContent/CardContent.component'
import CardHeader from '../CardHeader/CardHeader.component'

import { Divider, Paper } from '@mui/material'

const Card = ({ header, children }) => {

    /*
        header:
        - title
        - linkText
        - onLinkClick handler
    */

    return (<Paper variant='outlined' sx={{ marginTop: 4, marginBottom: 4}}>
        { header && <CardHeader {...header} /> }
        <Divider />
        <CardContent>{children}</CardContent>
    </Paper>)
}

export default Card